import { HStack, Text } from '@chakra-ui/react';
import Link from 'next/link';
import React, { FC } from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';

interface Props {
  href: string;
  text: string;
  showAsButton?: boolean;
}

export const ExternalDocumentLink: FC<Props> = ({
  href,
  text,
  showAsButton
}) => {
  return (
    <Link onClick={e => e.stopPropagation()} href={href} target="_blank">
      <HStack
        alignItems="center"
        gap={2}
        color="neutral.100"
        _hover={{ color: 'neutral.200' }}
        sx={
          showAsButton
            ? {
                padding: '8px 16px',
                background: 'neutral.800',
                border: '1px solid',
                borderColor: 'neutral.700',
                borderRadius: '8px'
              }
            : {}
        }
      >
        <Text fontSize="16px" textTransform="capitalize" textAlign="left">
          {text}
        </Text>
        <FaExternalLinkAlt />
      </HStack>
    </Link>
  );
};
